import { Box, Button, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { CloseCircle, TickCircle } from "iconsax-react";
import { useTranslation } from "react-i18next";

import { SefanoButton } from "@/components/Molecules";
import type { BillingCallbackTemplateProps } from "./BillingCallback.template.types";
import * as styles from "./BillingCallback.template.styles";

function BillingCallbackHeader() {
  return (
    <Box component="header" sx={styles.header}>
      <Box component="img" src="/images/nav_logo.png" alt="SEFANO" sx={styles.headerLogo} />
    </Box>
  );
}

export function BillingCallbackTemplate({
  isLoading,
  isError,
  isSuccess,
  onGoToBilling,
  onGoToDashboard,
}: BillingCallbackTemplateProps) {
  const { t } = useTranslation("billing");
  const theme = useTheme();

  return (
    <Box sx={styles.root}>
      <BillingCallbackHeader />

      <Box component="main" sx={styles.main}>
        <Box sx={styles.mainInner}>
          <Box sx={styles.statusCard}>
            {isLoading ? (
              <>
                <Box sx={styles.spinner(theme)} />
                <Typography sx={styles.statusTitle}>{t("callback.processing")}</Typography>
                <Typography sx={styles.statusDescription}>{t("callback.processingHint")}</Typography>
              </>
            ) : isError ? (
              <>
                <Box sx={styles.statusIconWrap("error")}>
                  <CloseCircle size={46} variant="Bold" color={theme.palette.error.main} />
                </Box>
                <Typography sx={styles.statusTitle}>{t("callback.failed")}</Typography>
                <Typography sx={styles.statusDescription}>{t("callback.failedDescription")}</Typography>
                <Box sx={styles.actions}>
                  <SefanoButton onClick={onGoToBilling} sx={{ minWidth: 170, minHeight: 46 }}>
                    {t("banner.viewBilling")}
                  </SefanoButton>
                </Box>
              </>
            ) : isSuccess ? (
              <>
                <Box sx={styles.statusIconWrap("success")}>
                  <TickCircle size={46} variant="Bold" color={theme.palette.success.main} />
                </Box>
                <Typography sx={styles.statusTitle}>{t("callback.success")}</Typography>
                <Typography sx={styles.statusDescription}>{t("callback.successDescription")}</Typography>
                <Typography sx={styles.redirectHint}>{t("callback.redirectHint")}</Typography>
                <Box sx={styles.actions}>
                  <Button
                    variant="outlined"
                    color="primary"
                    onClick={onGoToBilling}
                    sx={{ minWidth: 170, minHeight: 46, borderRadius: 1.5, fontWeight: 700 }}
                  >
                    {t("banner.viewBilling")}
                  </Button>
                  <SefanoButton onClick={onGoToDashboard} sx={{ minWidth: 170, minHeight: 46 }}>
                    {t("callback.goDashboard")}
                  </SefanoButton>
                </Box>
              </>
            ) : null}
          </Box>
        </Box>
      </Box>
    </Box>
  );
}
